import React from 'react'
import { useParams } from 'react-router-dom'
import AllRestaurantsSideBar from "../../sub-components/AllRestaurantsSideBar"
import CommonHeader from "../../sub-components/CommonHeader"
import Footer from '../../sub-components/Footer'
import Menu from "./Menu"



function MenusCategories() {
    const { id } = useParams()
  return (
    <div>
       <CommonHeader /> 
    <section
    style={{  
      backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.527),rgba(0, 0, 0, 0.5)) , url(" + "https://i0.wp.com/digital-photography-school.com/wp-content/uploads/2018/01/Charcuterie_Darina-Kopcok.jpg?ssl=1" + ")",
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
    }}
      className=" mt-20 bg-dark text-center">
      <h1 style={{marginTop:30}} className="text-white">Menu Categories</h1>
      <h6 className="text-white-50">Best deals at your favourite restaurants</h6>
    </section>
    <section className="section pt-5 pb-5 products-listing">
      <div className="container">
        <div className="row d-none-m">
          <div className="col-md-12">
            <div className="dropdown float-right">
              <a className="btn btn-outline-info dropdown-toggle btn-sm border-white-btn" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Sort by: <span className="text-theme">Distance</span> &nbsp;&nbsp;
              </a>
              <div className="dropdown-menu dropdown-menu-right shadow-sm border-0 ">
                <a className="dropdown-item" href="#">Distance</a>
                <a className="dropdown-item" href="#">No Of Offers</a>
                <a className="dropdown-item" href="#">Rating</a>
              </div>
            </div>
            <h4 className="font-weight-bold mt-0 mb-3">MENUs <small className="h6 mb-0 ml-2">Category - <span style={{fontWeight:'bolder'}}>{id}</span>
              </small>
            </h4>
          </div>
        </div>
        <div className="row">
        <div className="col-md-3">
          <AllRestaurantsSideBar id1={id}/>
          </div>
          <div className="col-md-9">
          <Menu id1={id}/>
          </div>
        </div>
      </div>
    </section>
    <Footer />
    </div>
  )
}

export default MenusCategories